var map = {
	"./app-store.svg": 88100,
	"./error.svg": 68067,
	"./generating-cashback-bg.svg": 56865,
	"./google-play.svg": 59080,
	"./grey-nfc-circle.svg": 81175,
	"./login-logo.svg": 38924,
	"./logo_holiday_color.svg": 65332,
	"./logo_holiday_white.svg": 57339,
	"./nfc-wider.svg": 45632,
	"./nfc.svg": 86645,
	"./p24.svg": 10877,
	"./payu.svg": 1447,
	"./percent-watermark.svg": 56821,
	"./processing.svg": 85537,
	"./success.svg": 41185,
	"./tag.svg": 95300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29866;